import { useNuxtApp } from "#imports";
export function useTrackEvent(eventName, options) {
  if (import.meta.client) {
    ;
    useNuxtApp().$plausible?.trackEvent(eventName, options);
  }
}
